"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

// Decorative 3D server scene on the Console page. Split into its own chunk and
// mounted after the first interaction or a short idle window, so it never blocks
// first paint. The placeholder is the same fixed-height box, so there is no shift.
const ConsoleScene = dynamic(() => import("@/components/ConsoleScene"), {
  ssr: false,
  loading: () => <div className="console-scene" aria-hidden="true" />,
});

export default function LazyConsoleScene() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const events = ["scroll", "pointerdown", "pointermove", "touchstart", "wheel", "keydown"];
    const go = () => {
      events.forEach((e) => window.removeEventListener(e, go));
      setReady(true);
    };
    events.forEach((e) => window.addEventListener(e, go, { passive: true }));
    return () => {
      events.forEach((e) => window.removeEventListener(e, go));
    };
  }, []);

  return ready ? <ConsoleScene /> : <div className="console-scene" aria-hidden="true" />;
}
